import EventBus from '@/plugins/eventbus'
import { stateGetters, stateSetters } from '@/store/store-utils'

const defaultState = {
  items: null,
}

export default {
  name: 'items',
  namespaced: true,
  state: () => defaultState,
  getters: stateGetters(defaultState),
  mutations: stateSetters(defaultState),
  actions: {
    async getItems({ commit }, hash) {
      const resp = await this.$api.items.get(hash)

      // if hash matches, short circuit and use localstorage
      if (resp === true) return true

      const { data: itemData } = resp
      const items = itemData.items.reduce((acc, item) => {
        acc[item.n] = {
          name: item.n,
          color: `#${itemData.c[item.c]}`,
          image: item.i,
          category: itemData.tc[item.tc],
          type: itemData.tt[item.tt],
        }
        return acc
      }, {})

      // parse
      return {
        hash: resp.hash,
        items,
      }
    },
  },
}

EventBus.$once('app.created', async vm => {
  const localHash = vm.$ls.get('itemdb.hash', null)
  const localItems = vm.$ls.get('itemdb', null)

  // only send hash if we actually have items too
  const resp = await vm.$store.dispatch('items/getItems', localItems && localHash)

  // if hash matches and we have items
  if (resp === true) {
    vm.$store.commit('items/setItems', localItems)
    return
  }

  vm.$store.commit('items/setItems', resp.items)
  vm.$ls.set('itemdb.hash', resp.hash)
  vm.$ls.set('itemdb', resp.items)
})
